import MultiImageViewModal from 'components/Onboarding/Mle/BusinessTab/MultiImageViewModal'
import { getFileListUrls } from 'components/Onboarding/Mle/mle.utils';
import React, { useState } from 'react'

const MultiViewChecker = ({list}) => {
    console.log("list", list);
    const [multiViewDocument, setMultiViewDocument] = useState(null);
    const fetchViewUrl = async () => {
        
        if (list?.length) {
            try {
                
                const urls = await getFileListUrls(list);
                console.log("urls", urls);
                setMultiViewDocument(urls.filter(url => !!url));
            } catch (error) {
                console.error('Error fetching URLs:', error);
                // Optionally, handle the error further (e.g., show a user-friendly message)
            }
        }
    }
    const handleViewClick = () => {
        fetchViewUrl();
    }
  return (
    <>
        {
            multiViewDocument && (
                <MultiImageViewModal
                    multiDocuments={multiViewDocument}
                    setMultiDocuments={setMultiViewDocument} 
                />
            )
        }
        <button
            className="view-link"
            onClick={() => handleViewClick()}
        >
            View
        </button>
    </>
  )
}

export default MultiViewChecker
